export default __webpack_public_path__ + "static/media/msf_logo.c45afdd5.svg";